import type { User } from '../api';

/** How long after a trial lapses the "trial ended" modal may still appear. */
const TRIAL_ENDED_WINDOW_DAYS = 14;

const seenKey = (userId: string) => `nr-trial-ended-seen:${userId}`;

/**
 * True when the user's free trial lapsed in the last two weeks and they never
 * paid. `stripe_customer_id` excludes subscribers who later canceled: their
 * `trial_ends_at` is also in the past, but "your trial has ended" would be wrong.
 */
export function trialJustEnded(user: User, now = Date.now()): boolean {
  if (user.plan !== 'free' || user.is_trialing || !user.trial_ends_at || user.stripe_customer_id) return false;
  // D1 datetimes are UTC without a zone marker.
  const endedAt = Date.parse(user.trial_ends_at.replace(' ', 'T') + 'Z');
  if (Number.isNaN(endedAt) || endedAt > now) return false;
  return now - endedAt <= TRIAL_ENDED_WINDOW_DAYS * 86_400_000;
}

export function hasSeenTrialEnded(userId: string): boolean {
  try { return localStorage.getItem(seenKey(userId)) === '1'; } catch { return false; }
}

export function markTrialEndedSeen(userId: string): void {
  try { localStorage.setItem(seenKey(userId), '1'); } catch { /* shown again next load */ }
}
